/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 14:45:16
 * @LastEditors: 诺
 * @LastEditTime: 2023-04-10 15:04:23
 * @Description: file content
 */
import qs from "qs";
import api from "@/api/act-logic-dengfan"
import myAxios from "./interceptors"
import Vue from 'vue/dist/vue.js';
let axios = new myAxios();
let _options = {};
import util from '@/utils/common';
import sign from '@/utils/sign'

const saleHost = process.env.VUE_APP_API;
const host = process.env.VUE_APP_BASEAPI;
console.log(api, 'api', process.env.VUE_APP_SERVE_ENV)

const urlList = [
  'prize/writeOff',
  'getPrizeInfo',
  'complaint',
  'writeOffCode/detail',
  'writeOffCode/writeOff',
]
const Mock = require('mockjs');
// Add a request interceptor
axios.axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // console.log("http interceptors by act-logic-dengfan");

  if (!Vue.prototype.$projectId && util.cookie.get("configInfo")) {
    Vue.prototype.$projectId = JSON.parse(util.cookie.get("configInfo")).projectId
  }
  urlList.map(item => {
    if (config.url.indexOf(item) > -1) {
      config.url = `${saleHost}${config.url}`;
    }
  })


  if (config.url.indexOf('http://') > -1 || config.url.indexOf('https://') > -1) {
    config.url = `${config.url}`;
  } else {
    // config.url = `${api.protocol}//${api.domain}${config.url}`;
    config.url = `${host}${config.url}`;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
// Add a response interceptor
axios.axios.interceptors.response.use(function (response) {
  if (response.config.headers.res) {
    switch (response.config.headers.res) {
      case 'data':
        if (response.data) {
          response = response.data;
        }
        break;
      case 'data2':
        if (response.data && response.data.hasOwnProperty('data')) {
          response = response.data.data;
        } else {
          return Promise.reject(response);
        }
        break;
      default:
        break;
    }
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});

export default {
  options: _options,
  qs: qs,
  getMock(url, param, addParam) {
    if (typeof url == "object" && url.mock) {
      Mock.mock(new RegExp(`${api.protocol}//${api.domain}${url.api}` + "?."), 'get', url.mock);
    } else {
      throw new Error("没有配置mock数据");
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "get",
        url: realUrl,
        params: param,
        headers: addParam
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  get(url, param, addParam) {
    if (process.env.VUE_APP_MOCK == 1) {
      if (typeof url == "object" && url.mock) {
        Mock.mock(`${api.protocol}//${api.domain}${url.api}`, 'get', url.mock);
      } else {
        console.warn(`已启动全局mock，但 ${url} 没有配置mock数据，请留意`);
      }
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }

    let header={
      // actCode  openId  fromOpenId  fromSaleOpenId  channelId  projectId  appId
      actCode:Vue.prototype.$actCode||'',
      openId:Vue.prototype.$openid||'',
      fromOpenId:Vue.prototype.$fopenid||'',
      fromSaleOpenId:Vue.prototype.$fromSaleOpenId||'',
      channelId:Vue.prototype.$channel||1,
      projectId:Vue.prototype.$projectId||'',
      appId:Vue.prototype.$appId||'',
    }
    if (url && url.indexOf(saleHost) > -1) {
      const Sign = new sign
      addParam = {
        ...addParam,
        // ...header,
        timestamp: Sign.timestamp,
        appKey: Sign.appKey,
        sign: Sign.createSign('/' + url.split(saleHost)[1]),
        version: Sign.version,
      }
    } else {
      const Sign = new sign
      addParam = {
        ...addParam,
        // ...header,
        timestamp: Sign.timestamp,
        actSignKey: Sign.signKey,
        actSign: Sign.paySign('/' +  url),
        version: Sign.version
      }
    }


    return new Promise((resolve, reject) => {
      axios.axios({
        method: "get",
        url: realUrl,
        params: param,
        headers: addParam
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  postMock(url, param, addParam) {
    if (typeof url == "object" && url.mock) {
      Mock.mock(`${api.protocol}//${api.domain}${url.api}`, 'post', url.mock);
    } else {
      throw new Error("没有配置mock数据");
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "post",
        url: realUrl,
        data: param,
        headers: addParam
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  post(url, param, addParam) {
    if (process.env.VUE_APP_MOCK == 1) {
      if (typeof url == "object" && url.mock) {
        Mock.mock(`${api.protocol}//${api.domain}${url.api}`, 'post', url.mock);
      } else {
        console.warn(`已启动全局mock，但 ${url} 没有配置mock数据，请留意`);
      }
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }
    const Sign = new sign
    urlList.map(item => {
      if (realUrl.indexOf(item) > -1) {
        addParam = {
          ...addParam,
          timestamp: Sign.timestamp,
          appKey: Sign.appKey,
          sign: Sign.createSign('/' + realUrl),
          version: Sign.version,
        }
      }
    })
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "post",
        url: realUrl,
        data: param,
        headers: addParam
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  put(url, param, addParam) {
    if (process.env.VUE_APP_MOCK == 1) {
      if (typeof url == "object" && url.mock) {
        Mock.mock(`${api.protocol}//${api.domain}${url.api}`, 'put', url.mock);
      } else {
        console.warn(`已启动全局mock，但 ${url} 没有配置mock数据，请留意`);
      }
    }
    let realUrl = "";
    if (typeof url == "object") {
      realUrl = url.api;
    } else {
      realUrl = url;
    }
    return new Promise((resolve, reject) => {
      axios.axios({
        method: "put",
        url: realUrl,
        data: param,
        headers: addParam
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
